export const environment = {
  production: true,
  apiUrl: 'https://dev.megapwr.com/api/',
  isDev: false
};
